// extracted by mini-css-extract-plugin
export default {"overlayTooltip":"EmissionCalculationError_overlayTooltip__oXpM5","tooltipContent":"EmissionCalculationError_tooltipContent__g8Moj"};